import React, { useState } from "react";
import {
  Grid,
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { printPlugin } from "@react-pdf-viewer/print";
import { getFilePlugin } from "@react-pdf-viewer/get-file";
import PDFView from "../../../../../components/PDFView";
import {
  CurrentPagePlugin,
  DownloadFilePlugin,
} from "../../../../../components/PDFView/Toolbar";
import { Fullscreen, CloseRounded, Print } from "@mui/icons-material";
import FullViewPDF from "../FullViewPDF";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  iconButton: {
    color: theme.palette.text.primary,
  },
}));

function FileFromStreamDialog({ file, onClose }) {
  const { classes } = useStyles();
  const theme = useTheme();
  const [isFullViewDialogOpen, setIsFullViewDialogOpen] = useState(false);
  const isXS = useMediaQuery(theme.breakpoints.down("sm"));
  const zoomPluginInstance1 = zoomPlugin();
  const pageNavigationPluginInstance1 = pageNavigationPlugin();
  const zoomPluginInstance2 = zoomPlugin();
  const pageNavigationPluginInstance2 = pageNavigationPlugin();
  const printPluginInstance = printPlugin();
  const getFilePluginInstance = getFilePlugin();

  const handleOpenDialog = () => {
    setIsFullViewDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsFullViewDialogOpen(false);
  };

  return (
    <Grid item size={{ md: 8 }} height={"100%"}>
      <>
        <Box
          height={"100%"}
          sx={{
            borderLeft: `1px solid ${theme.palette.divider}`,
            display: "flex",
            flexDirection: "column",
          }}>
          <Box
            px={2}
            py={1}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}>
            <Typography
              variant="body1"
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                lineHeight: 1.2,
                flex: 1,
                minWidth: 0,
                marginRight: 1,
                fontWeight: 600,
              }}>
              {file["name"]}
            </Typography>
            <Box display={"flex"} alignItems={"center"}>
              {file["url"] && (
                <>
                  <CurrentPagePlugin
                    pageNavigationPluginInstance={pageNavigationPluginInstance1}
                  />
                  <IconButton
                    className={classes.iconButton}
                    onClick={handleOpenDialog}>
                    <Fullscreen />
                  </IconButton>
                  <IconButton
                    className={classes.iconButton}
                    onClick={() => printPluginInstance.print()}>
                    <Print />
                  </IconButton>
                  <DownloadFilePlugin
                    getFilePluginInstance={getFilePluginInstance}
                    color={theme.palette.text.secondary}
                  />
                  <Divider orientation="vertical" sx={{ mx: 1, height: 24 }} />
                </>
              )}
              <IconButton className={classes.iconButton} onClick={onClose}>
                <CloseRounded />
              </IconButton>
            </Box>
          </Box>
          <Divider />
          <Box px={2} py={1}>
            <Typography variant="body2" noWrap>
              {file["section"]}
            </Typography>
          </Box>
          <Divider />
          <Box
            px={1}
            bgcolor={"#525659"}
            sx={{
              flex: 1,
              overflow: "auto",
              cursor: "pointer",
            }}>
            {file["url"] ? (
              <PDFView
                file={{ ...file, file_url: file["url"] }}
                scale={isXS ? 0.5 : 0.8}
                zoomPluginInstance={zoomPluginInstance1}
                pageNavigationPluginInstance={pageNavigationPluginInstance1}
                printPluginInstance={printPluginInstance}
                getFilePluginInstance={getFilePluginInstance}
              />
            ) : (
              <Typography sx={{ color: "white" }}>
                Error while loading the document
              </Typography>
            )}
          </Box>
        </Box>
        {isFullViewDialogOpen && (
          <FullViewPDF
            relatedDoc={{ ...file, file_url: file["url"] }}
            zoomPluginInstance={zoomPluginInstance2}
            pageNavigationPluginInstance={pageNavigationPluginInstance2}
            file={file}
            printPluginInstance={printPluginInstance}
            onClose={handleCloseDialog}
          />
        )}
      </>
    </Grid>
  );
}

export default FileFromStreamDialog;
